import { createFeatureSelector } from '@ngrx/store';
import { LOOKUP_FEATURE_STATE_KEY } from './lookup.key';
import { LookupFeatureStoreState } from './lookup.model';


export const selectLookupFeatureState = createFeatureSelector<LookupFeatureStoreState>(LOOKUP_FEATURE_STATE_KEY);
